import script from "./Navigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./Navigation.vue?vue&type=script&setup=true&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=38a9d979&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a9d979"]])

export default __exports__